<template>
  <section id="contests" class="contest">
    <h2 class="contest__title">Наши конкурсы</h2>
    <ul class="contest__cards">
      <li
        class="contest__card"
        v-for="(card, i) in contests"
        :key="i"
        @click="openPhoneModal"
      >
        <img :src="card.img" :alt="card.heading" class="contest__img-element" />
        <div class="contest__content">
          <div class="contest__text">
            <div class="contest__heading">{{ card.heading }}</div>
          </div>
          <div class="contest__button">
            <button class="button-2 dark">ПОДАТЬ ЗАЯВКУ</button>
          </div>
        </div>
      </li>
      <!-- ─────────────────────────────────────── -->
      <!-- Специальная полноширинная карточка в конце -->
      <li class="contest__card-fullwidth">
        <div class="fullwidth__inner">
          <div class="fullwidth__content">
            <p class="fullwidth__text">
              «РИТМ ЛЕТА» — хореографический конкурс, направленный на поддержку
              и развитие талантливых хореографических коллективов. Финансовое
              обеспечение проведения мероприятия осуществляется за счёт
              собственных средств организатора, что обеспечивает бесплатное
              участие.
            </p>
            <button class="button-2 dark fullwidth__btn">
              Cтарт подачи заявок 1 июля 2026 года
            </button>
          </div>
        </div>
        <div class="fullwidth__content-mobile">
          <p class="fullwidth__text">
            «РИТМ ЛЕТА» — хореографический конкурс, направленный на поддержку и
            развитие талантливых хореографических коллективов. Финансовое
            обеспечение проведения мероприятия осуществляется за счёт
            собственных средств организатора, что обеспечивает бесплатное
            участие.
          </p>
          <button class="button-2 dark fullwidth__btn">
            Подача заявок 1 июля 2026 года
          </button>
        </div>
      </li>
      <!-- ─────────────────────────────────────── -->
    </ul>
  </section>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { useModalStore } from "@/stores/modals";
export default {
  data() {
    return {
      activeCard: null,
      contests: [
        {
          heading: "ПРЯМОЕ ВКЛЮЧЕНИЕ\nВ ПРЯМОМ ЭФИРЕ",
          img: require("@/assets/images/section-contest/PV-online.jpg"),
        },
        {
          heading: "ПРЯМОЕ ВКЛЮЧЕНИЕ ПОЛУФИНАЛ",
          img: require("@/assets/images/section-contest/PV-polufinal.png"),
        },
        {
          heading: "ПРЯМОЕ ВКЛЮЧЕНИЕ ФИНАЛ",
          img: require("@/assets/images/section-contest/PV-final.png"),
        },
        {
          heading: "4FEST\nПРЕМИЯ ЛАУРЕАТОВ",
          img: require("@/assets/images/section-contest/4-fest.png"),
        },
        {
          heading: "KONKURENT ТАНЦЕВАЛЬНЫЙ ФЕСТИВАЛЬ",
          img: require("@/assets/images/section-contest/konkurent.png"),
        },
        {
          heading: "КУЛЬТУРНОЕ НАСЛЕДИЕ",
          img: require("@/assets/images/section-contest/nasledie.png"),
        },
      ],
    };
  },
  setup() {
    // Важно: получаем store в setup и возвращаем в компонент
    const authStore = useAuthStore();
    const modalStore = useModalStore();
    return { authStore, modalStore };
  },

  methods: {
    openPhoneModal() {
      this.modalStore.openPhoneModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.contest {
  padding: 2.93% 10.5%;
  color: #262626;
  background-color: #fcf5eb;
}

.contest__title {
  margin-bottom: 3.333333vw;
}

.contest__cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1.666667vw;
  list-style: none;
  padding: 0;
}

.contest__card {
  flex: 1 1 calc(25% - 0.729167vw);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  transition: transform 0.3s ease;
}

.contest__img-element {
  width: 100%;
  height: 15.020833vw;
  object-fit: cover;
  margin-bottom: 1.25vw;
  border-radius: 0.833333vw;
}

.contest__content {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 1vw;
}

.contest__text {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.520833vw;
}

.contest__heading {
  font-family: "Oswald", sans-serif;
  font-size: 1.25vw;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 0.260417vw;
  white-space: pre-line;
}

.contest__date {
  font-family: "Inter", sans-serif;
  white-space: nowrap;
  font-size: 0.833333vw;
  font-weight: 400;
}

.contest__button {
  display: flex;
  align-items: center;
  gap: 0.520833vw;
}

.dark {
  border-color: #262626;
  color: #262626;
  font-weight: 600;
}
.contest__card:hover {
  transform: scale(1.02);
}
/* Полноширинная карточка */
.contest__card-fullwidth {
  flex: 1 1 100%; // занимает всю ширину
  margin-top: 2.5vw; // визуальный отступ от предыдущих карточек
  list-style: none;
  cursor: pointer;
  border-radius: 0.833333vw;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.contest__card-fullwidth:hover {
  transform: scale(1.015);
}

/* Внутренний контейнер с фоном */
.fullwidth__inner {
  position: relative;
  min-height: 15vw; // примерная высота — подстрой под себя
  background: url("@/assets/images/section-contest/leto.png") no-repeat left
    center;
  background-size: contain;
  color: white;
  display: flex;
  justify-content: flex-end;
  padding: 1vw 10vw;
}

/* Контент справа */
.fullwidth__content {
  max-width: 60%; // ← оставляем
  text-align: left;
}
.fullwidth__content-mobile {
  display: none;
}
.fullwidth__title {
  font-family: "Oswald", sans-serif;
  font-size: 2.2vw;
  text-transform: uppercase;
  margin-bottom: 1vw;
  line-height: 1.1;
}

.fullwidth__text {
  font-family: "Inter", sans-serif;
  font-size: 1.1vw;
  line-height: 1.5;
  margin-bottom: 1.5vw;
  opacity: 0.95;
}

.fullwidth__btn {
  font-size: 1.1vw;
  padding: 0.8vw 2vw;
}

/* Адаптив для мобильных */
@media (max-width: 768px) {
  .contest__card-fullwidth {
    margin-top: 6vw;
  }

  .fullwidth__inner {
    height: 50vw;
    padding: 8vw 6vw;
    justify-content: center; // на мобильных центрируем
    background: url("@/assets/images/section-contest/leto.png") no-repeat -60px center;
    background-size: cover;
    border-radius: 20px;
  }

  .fullwidth__content {
    display: none;
  }
  .fullwidth__content-mobile {
    display: block;
  }
  .fullwidth__title {
    font-size: 7.5vw;
  }

  .fullwidth__text {
    font-size: 4.2vw;
  }

  .fullwidth__btn {
    font-size: 4.5vw;
    padding: 3vw 8vw;
  }
}
/* Адаптив */
@media (max-width: 768px) {
  .contest {
    padding: 4.975vw;
  }
  .contest__title {
    font-size: 5.97vw;
    margin-bottom: 7.96vw;
  }
  .contest__card {
    flex: 1 1 100%;
    margin-bottom: 3vw;
  }
  .contest__heading {
    font-size: 4.975vw;
  }
  .contest__img-element {
    width: 90.05vw;
    height: 55.3vw;
    border-radius: 3.98vw;
  }
  .contest__text {
    flex-direction: column;
  }
  .contest__date {
    font-size: 3.483vw;
  }
  .contest__button-element {
    font-size: 4.975vw;
  }
}
</style>